import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { throttle } from '../../../helpers/throttle';
import {
  getCampaignElementById,
  updateCampaignElementValue
} from '../../../redux/modules/campaignLandingPage';
import { CampaignLandingElementWrapper } from '../..';
import { VpHookFormRatingInput } from '../../inputs';

const CampaignRatingInput = ({ _updateCampaignElementValue, element, qid }) => {
  const [isTouched, setIsTouched] = useState(false);
  const [isValid, setIsValid] = useState(true);

  return (
    <CampaignLandingElementWrapper
      isTouched={isTouched}
      isValid={isValid}
      required={element?.required}
      label={element?.label}
    >
      <VpHookFormRatingInput
        name="stars"
        disableHelperText
        returnString
        onChange={(value) => {
          if (element.required && value === '') {
            setIsValid(false);
          }
          setIsTouched(true);
          if (!element.required && value === '') {
            setIsTouched(false);
          }
          if (element.required) {
            setIsValid(value !== '');
          }
          throttle(() => _updateCampaignElementValue({ qid, value }), 1000)();
        }}
      />
    </CampaignLandingElementWrapper>
  );
};

CampaignRatingInput.propTypes = {
  _updateCampaignElementValue: PropTypes.func,
  qid: PropTypes.string,
  element: PropTypes.object
};

function mapStateToProps(state, ownProps) {
  return {
    element: getCampaignElementById(state, ownProps.qid)
  };
}

const mapDispatchToProps = {
  _updateCampaignElementValue: updateCampaignElementValue
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignRatingInput);



// WEBPACK FOOTER //
// ./src/vp-ui/components/CampaignRatingInput/CampaignRatingInput.jsx